"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
* Utils.ts
* Author: Brent Erickson (brericks) and Abhilash Panwar (abpanwar)
* Copyright: Microsoft 2016
* Common functions used in the SDK.
*/
var microsoft_bond_primitives_1 = require("../bond/microsoft.bond.primitives");
var GuidRegex = /[xy]/g;
function numberToBondInt64(value) {
    // Construct bond timestamp for aria
    var bond_value = new microsoft_bond_primitives_1.Int64('0');
    bond_value.low = value & 0xffffffff;
    bond_value.high = Math.floor(value / 0x100000000);
    return bond_value;
}
exports.numberToBondInt64 = numberToBondInt64;
function newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(GuidRegex, function (c) {
        var r = (Math.random() * 16 | 0), v = (c === 'x' ? r : r & 0x3 | 0x8);
        return v.toString(16);
    });
}
exports.newGuid = newGuid;
function isPii(value) {
    if (!isNaN(value) && value !== null && value >= 0 && value <= 13) {
        return true;
    }
    return false;
}
exports.isPii = isPii;
